import { matchPath } from 'react-router-dom';
import { routeUrlGenerator } from '@bg-shared/utils/routeUrlGenerator';

export const getMatchedGameId = (pathname: string) => {
    const match = matchPath(
        {
            path: `/${routeUrlGenerator.routes.GAME}/:gameId`,
            end: false,
        },
        pathname,
    );

    return match?.params.gameId ? Number(match.params.gameId) : null;
};
